import { Component, OnInit, Renderer2 } from "@angular/core";
import { Platform } from "@ionic/angular";
import { SystemBars, SystemBarsStyle } from "@capacitor/core";
import { SafeArea } from "capacitor-plugin-safe-area";

import { Observable } from "rxjs";

import {
  ApplicationService,
  UserService,
  VersionCheckService,
  WindowRefService,
} from "./core/services";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  isIframe = false;
  minimizeModal$: Observable<string> =
    this.applicationService.minimizeModalEvent$.asObservable();
  isShownAppSpinner$ = this.applicationService.isShownAppSpinner$;

  constructor(
    private platform: Platform,
    private applicationService: ApplicationService,
    private renderer2: Renderer2,
    private windowRefService: WindowRefService,
    private userService: UserService,
    private versionCheckService: VersionCheckService
  ) {}

  ngOnInit() {
    this.initializeApp();
  }

  async initializeApp() {
    // avoid using app via iframe
    const window = this.windowRefService.window;
    this.isIframe = window !== window.parent && !window.opener;

    this.applicationService.setDeviceInfo();
    await this.platform.ready();

    if (this.platform.is("android") || this.platform.is("ios")) {
      await SystemBars.setStyle({ style: SystemBarsStyle.Default });
    }
    this.applicationService.initRenderer(this.renderer2);
    this.userService.checkAccessToken();
    this.versionCheckService.start();

    const { insets } = await SafeArea.getSafeAreaInsets()
    const style = document.body.style;

    style.setProperty("--ion-safe-area-top", `${insets.top}px`);

    style.setProperty(
      "--ion-safe-area-right",
      `${insets.right}px`
    );

    style.setProperty(
      "--ion-safe-area-bottom",
      `${insets.bottom}px`
    );

    style.setProperty(
      "--ion-safe-area-left",
      `${insets.left}px`
    );
  }

  displayModal() {
    this.applicationService.minimizeCurrentModal(null);
  }
}
